import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { trilhaGenerationsApi } from '@/services/trilhaGenerations';

/**
 * Etapas da matriz SAEB disponíveis, vindas do backend
 * (GET /admin/trilha_generations/etapas). As etapas NÃO devem ser hardcoded
 * no frontend: o backend filtra as habilitadas para o app.
 *
 * Cada item: { etapa, label, total_descriptors, descriptors_with_content, learning_path }.
 *
 * Uso:
 *   const { etapas, loading } = useMatrizEtapas();
 *   const { etapas } = useMatrizEtapas({ enabled: open }); // só busca quando habilitado
 */
export default function useMatrizEtapas({ enabled = true } = {}) {
  const [etapas, setEtapas] = useState([]);
  const [loading, setLoading] = useState(enabled);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!enabled || loaded) return undefined;
    let mounted = true;
    setLoading(true);
    trilhaGenerationsApi
      .etapas()
      .then(json => {
        if (!mounted) return;
        setEtapas(json?.data || []);
        setLoaded(true);
      })
      .catch(() => {
        if (mounted) toast.error('Erro ao carregar etapas da matriz');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [enabled, loaded]);

  return { etapas, loading };
}
